<h2 mat-dialog-title>Delete Confirmation</h2>
<mat-dialog-content>
  Are you sure you want to delete <strong>{{ data.itemName }}</strong>?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="warn" (click)="confirm()">Delete</button>
</mat-dialog-actions>
